const dynamicPackage = {
  detailedPlan: "Αναλυτικό Σχέδιο", // translated
  minimum: "Ελάχιστο", // translated
  maximum: "Ανώτατο όριο", // translated
};

export default dynamicPackage;
